import React, { useState } from 'react';
import { Col, Row } from 'antd';
import LembretesIcon from '../assets/iconLembretes.png';
import {
  ArrowLeftOutlined,
  PlusOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import './Lembretes.scss';
import { useNavigate } from 'react-router-dom'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  backgroundColor: '#ebebeb',
  color: '#555555',
  boxShadow: 24,
  p: 4,
};

const horariosText = {
  '09:00': 'Café da Manhã',
  '12:00': 'Almoço',
  '14:00': 'Lanche 1',
  '17:30': 'Lanche 2',
  '21:00': 'Jantar'
}

const formulas = ["PKU nutri concentrated 1", "PKU nutri concentrated 2", "PKU nutri concentrated 3", "PKU Med A", "PKU Med B", "PKU Med C", "NEO PKU 2", "NEO PKU 3", "MSUD MED A Plus", "MSUD MED B Plus", "MSUD 2 Prima", "MMAPA Anamix Infant", "XMTVI Maxamaid", "OAC MED A Plus", "OAC MED B Plus", "Tyr Anamix Infant", "XPT Maxamaid", "Tyro MED A", "Tyro MED B", "HCYS MED A Plus", "HCYS MED B Plus", "XMET Maxamum", "URC Med A Plus", "URC Med B Plus", "Leu Med A", "Leu Med B", "GAcMed A", "GAcMed B", "Anamix Infant MMA/PA", "Anamix Junior MMA/PA", "Anamix Infant TYR ", "Anamix Junior TYR", "Anamix Junior HCU "]
const horarios = [
  '09:00',
  '12:00',
  '14:00',
  '17:30',
  '21:00'
]

const Lembretes = () => {
  let navigate = useNavigate();
  const [horario, setHorario] = React.useState('');
  const [formula, setFormula] = React.useState('');
  const [openModal, setOpenModal] = useState(false)
  const [checked, setChecked] = React.useState([]);
  const [lembretes, setLembretes] = React.useState([]);
  const [quantidade, setQuantidade] = React.useState(0);
  const [horarioConsumo, setHorarioConsumo] = React.useState('');

  React.useEffect(() => {
    const storageLembretes = JSON.parse(localStorage.getItem("lembretes"))
    if (storageLembretes) {
      setLembretes(storageLembretes)
      storageLembretes.map(function (item, i) {
        if (item.ativado) {
          let aux = checked
          aux.push(i)
          setChecked(aux)
        }
      })
    }
    console.log('DIARIO')
  }, [])

  const onClickBack = () => {
    console.log("click")
    navigate('/', { replace: true });
  }

  const handleChange = (event) => {
    setHorario(event.target.value);
  };

  const handleChangeFormula = (event) => {
    setFormula(event.target.value);
  };

  const handleChangeQuantidade = (event) => {
    setQuantidade(event.target.value)
  }

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    let aux = lembretes
    console.log(value)
    if (currentIndex === -1) {
      newChecked.push(value);
      aux[value].ativado = true
    } else {
      newChecked.splice(currentIndex, 1);
      aux[value].ativado = false
    }
    setLembretes(aux)
    setChecked(newChecked);
    localStorage.setItem("lembretes", JSON.stringify(aux))
  };

  const handleCloseModal = () => setOpenModal(false);

  const saveLembrete = () => {
    const newLembrete = {
      horario: horario,
      formula: formula,
      ativado: true,
      quantidade: quantidade,
      horarioConsumo: horarioConsumo
    }
    let aux = lembretes
    aux.push(newLembrete)
    setLembretes(aux)
    let aux2 = checked
    aux2.push(horarios.indexOf(horario))
    setChecked(aux2)
    localStorage.setItem("lembretes", JSON.stringify(lembretes))
    setOpenModal(false)
  }

  const onChangeHourPicker = (value) => {
    const hour = value.$H
    const minutes = value.$m
    const alert = hour + ":" + minutes
    setHorarioConsumo(alert)
  }

  function deleteLembrete(i) {
    console.log("delete")
    let aux = lembretes
    aux.splice(i, 1)
    localStorage.setItem("lembretes", JSON.stringify(aux))
    setLembretes(aux)
    window.location.reload(false);
  }

  return (
    <div className='lembretes'>
      <Row>
        <Col span={24} className='lembretes__header'>
          <ArrowLeftOutlined className='lembretes__icons' onClick={onClickBack} />
          <img src={LembretesIcon} alt='' className='lembretes__logo' />
          <p className='lembretes__title'>Lembretes de Fórmula</p>
        </Col>
      </Row>


      <div className='lembretes__cardSearch' onClick={() => setOpenModal(true)}>
        <PlusOutlined style={{ marginRight: 10 }} />
        Criar Lembrete
      </div>


      <Divider className='lembretes__divider'>Seus Lembretes</Divider>

      <div className='lembretes__list'>
        <List
          sx={{ width: '100%', maxWidth: 360 }}
        >
          {
            lembretes.map(function (item, i) {
              return (
                <ListItem>
                  <ListItemText id={"switch-list-label-" + i} primary={item.horarioConsumo ? item.horarioConsumo : item.horario} />
                  <ListItemText id={"switch-list-label-" + i} primary={item.formula} />
                  <Switch
                    edge="end"
                    onChange={handleToggle(i)}
                    checked={checked.indexOf(i) !== -1}
                    inputProps={{
                      'aria-labelledby': 'switch-list-label-' + i,
                    }}
                  />
                  <ListItemIcon style={{ minWidth: 0, marginLeft: 20 }} onClick={() => deleteLembrete(i)}>
                    <DeleteOutlined />
                  </ListItemIcon>
                </ListItem>
              )
            })
          }
        </List>
      </div>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2>Criar Lembrete</h2>
          <div>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 260 }}>
              <InputLabel id="demo-simple-select-standard-label">Fórmula Metabólica</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={formula}
                onChange={handleChangeFormula}
                label="Horário"
              >
                {
                  formulas.map(function (item, i) {
                    return (
                      <MenuItem value={item}>
                        <em>{item}</em>
                      </MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </div>

          <div style={{ marginTop: 10, maxWidth: 270 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={[
                  'MobileTimePicker',
                ]}
              >
                <DemoItem label="Horário de Consumo">
                  <MobileTimePicker defaultValue={dayjs('2022-04-17T15:30')} onChange={onChangeHourPicker} />
                </DemoItem>
              </DemoContainer>
            </LocalizationProvider>
          </div>

          <div style={{ marginTop: 10 }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 260 }}>
              <InputLabel id="demo-simple-select-standard-label">Incluir em qual refeição do diário?</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={horario}
                onChange={handleChange}
                label="Horário"
              >
                {
                  horarios.map(function (item, i) {
                    return (
                      <MenuItem value={item}>
                        <em>{horariosText[item]}</em>
                      </MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </div>

          <div style={{ marginTop: 28, marginLeft: 10 }}>
            <TextField
              id="standard-number"
              label="Quantidade Consumida (g)"
              type="number"
              value={quantidade}
              onChange={handleChangeQuantidade}
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
            />

          </div>

          <div className='lembretes__cardSearch' onClick={() => saveLembrete()}>
            Salvar
          </div>
        </Box>
      </Modal>

    </div>
  )
}

export default Lembretes
